import React, { useEffect, useState } from "react";
// import { IoMdArrowDropdown } from "react-icons/io";
import { IoCart } from "react-icons/io5";
// import { GoHeart } from "react-icons/go";
import { FaPlus } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { addProductToCart } from "../../store/productSlice";
import { FaMinus } from "react-icons/fa6";
import { languageHelper } from "../../config/helperFunctions";
import { toast } from "react-toastify";
import AlertModal from "./AlertModal";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function ProductModal({ toggle, menu, settings, subData, currency }) {
  const [quantity, setQuantity] = useState(1);
  const [modifiers, setModifiers] = useState([]);
  const [alert, setAlert] = useState(false);
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.products.cart);

  const categoryCart = cart.filter(
    (item) => item.category_id === menu.category_id
  );

  const sumCart = categoryCart.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const [sumCatCart, setSumCatCart] = useState(sumCart + 1);

  const allowedQuantity = subData?.quantity;

  const handleModifierSelect = (modifierId, modifierPrice, modifier_name) => {
    setModifiers((prev) => {
      const exists = prev.some(
        (modifier) => modifier.modifier_id === modifierId
      );
      if (exists) {
        // Remove the modifier if it exists
        return prev.filter((modifier) => modifier.modifier_id !== modifierId);
      } else {
        // Add the modifier if it does not exist
        return [
          ...prev,
          {
            modifier_id: modifierId,
            modifier_name,
            quantity: 1,
            modifier_price: modifierPrice,
          },
        ];
      }
    });
  };

  const handleAddQuantity = () => {
    setQuantity(quantity + 1);
    setSumCatCart(sumCatCart + 1);
  };

  const handleSubQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
      setSumCatCart(sumCatCart - 1);
    }
  };

  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);

  return (
    <>
      <div
        className="w-screen h-screen fixed top-0 left-0 bottom-0 overflow-y-auto backdrop-blur-xl bg-black bg-opacity-20 z-50 grid place-items-center p-4 fade-in"
        onClick={() => toggle()}
      >
        <div
          className="max-w-lg w-full rounded-lg shadow-lg bg-white p-3 relative fade-in-down"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => toggle()}
            className="absolute top-3 right-3 md:top-6 md:right-6"
          >
            <RxCross2 className="text-[#774d96] text-lg" />
          </button>
          <div className="border border-gray-200 rounded-lg p-4">
            <img
              className="w-80 h-60 mx-auto"
              src={menu.photo_url}
              alt="Card"
              loading="lazy"
            />
            <div className="pt-1">
              <div className="font-bold text-xl text-w-heading mb-2">
                {defaultLang === "text_en" ? menu.name : menu.name_arabic}
              </div>
              {settings?.product_description === "active" && (
                <p className="text-gray-700 text-w-heading text-base">
                  {menu.description}
                </p>
              )}
            </div>
            <h4 className="font-bold text-xl px-1 py-1">
              {languageHelper("addon") || "Addo"}
            </h4>
            <div className="flex flex-wrap">
              {menu.modifiers.map((mod, index) => {
                const isSelected = modifiers.some(
                  (m) => m.modifier_id === mod.modifier.id
                );

                return (
                  <button
                    key={index}
                    onClick={() =>
                      handleModifierSelect(
                        mod.modifier.id,
                        mod.modifier.price,
                        mod.modifier.name
                      )
                    }
                    className={`flex border border-w-border rounded items-center 
                  px-2 mr-2 text-sm  ${isSelected ? "bg-w-btn text-w-btn-text" : "text-w-btn"
                      }`}
                  >
                    <span>
                      {mod.modifier.name} <br />
                      {mod.modifier.price} {currency || "S.R"}
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="px-1 justify-between flex ">
              <div className="flex items-center   text-w-heading px-2  mr-2">
                <span className="">
                  <br />
                </span>
              </div>

              <div className="flex items-end font-bold text-xm  text-w-heading  mr-2">
                <span className="">
                  {currency || "S.R"}{""}
                  <span
                    className={`${menu.discount.length > 0 && "line-through"}`}
                  >
                    {" "}
                    {menu.tax_method === "inclusive"
                      ? menu.sale_price
                      : menu.sale_price + menu.sale_price_vat_price}
                  </span>{" "}
                  {menu.discount.length > 0 && (
                    <span>
                      {menu.tax_method === "inclusive"
                        ? menu.sale_price -
                        (menu.discount[0]?.dis_type === "amount"
                          ? menu.discount[0]?.discount_amount
                          : menu.sale_price *
                          (menu.discount[0]?.discount_amount / 100))
                        : menu.sale_price -
                        (menu.discount[0]?.dis_type === "amount"
                          ? menu.discount[0]?.discount_amount
                          : menu.sale_price *
                          (menu.discount[0]?.discount_amount / 100)) +
                        menu.sale_price_vat_price}
                    </span>
                  )}{" "}
                </span>
              </div>
            </div>

            <div className=" flex justify-between ">
              <div className="flex items-left text-w-heading px-2 mr-2">
                <span className="">
                  {menu.tax_method === "exlcusive"
                    ? languageHelper("excluding vat") || "Excluding VAT"
                    : languageHelper("including vat") || "Including VAT"}{" "}
                  {menu.vat.percentage}%
                </span>
              </div>

              <div className="flex items-end text-w-heading mr-2">
                <span className="">{menu.sale_price_vat_price}</span>
              </div>
            </div>

            {menu.sale_price_extra_vat_price !== 0 && (
              <div className="flex justify-between">
                <div className="flex items-left text-w-heading px-2  mr-2">
                  <span className="">
                    {languageHelper("extra vat") || "Extra VAT"} 100%
                  </span>
                </div>

                <div className="flex items-end text-w-heading mr-2">
                  <span className="">{menu.sale_price_extra_vat_price}</span>
                </div>
              </div>
            )}

            <div className="px-1 flex flex-wrap justify-between gap-2">
              <div className="flex items-center bg-white border border-w-border  text-w-heading px-2 rounded mr-2">
                <div className="flex items-center justify-center py-1  ps-1">
                  <button
                    className="text-w-btn-text bg-w-bg p-0.5 text-xs rounded"
                    onClick={handleSubQuantity}
                  >
                    <FaMinus />
                  </button>
                  <span className="px-2 py-1 w-12 text-center">{quantity}</span>
                  <button
                    className="text-w-btn-text bg-w-bg p-0.5 text-xs rounded"
                    onClick={handleAddQuantity}
                    disabled={allowedQuantity <= sumCatCart}
                  >
                    <FaPlus />
                  </button>
                </div>
              </div>
              <div className="flex font-bold text-center text-w-heading px-2 py-3">
                {currency || "S.R"} {(menu.sale_price_total_price * quantity).toFixed(2)}
              </div>
              <button
                onClick={() => {
                  if (allowedQuantity < sumCatCart) {
                    setAlert(
                      languageHelper(
                        "You have reached the maximum allowed quantity for this category in your subscription."
                      )
                    );
                    return;
                  }
                  dispatch(
                    addProductToCart({
                      item_id: menu.id,
                      category_id: menu.category_id,
                      name: menu.name,
                      name_arabic: menu.name_arabic,
                      price: menu.sale_price,
                      discount:
                        menu.discount[0]?.dis_type === "amount"
                          ? menu.discount[0]?.discount_amount
                          : menu.sale_price *
                          (menu.discount[0]?.discount_amount / 100),
                      tax_method: menu.tax_method,
                      extra_vat: menu.sale_price_extra_vat_price,
                      vat: menu.sale_price_vat_price,
                      final_price: menu.sale_price_total_price,
                      quantity: quantity,
                      menu_note: "",
                      image: menu.photo_url,
                      modifiers: modifiers,
                    })
                  );
                  toast.success("Item added to cart", {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                  toggle();
                }}
                className="flex items-center bg-white border border-w-border text-w-btn hover:bg-w-btn hover:text-w-btn-text px-1 pe-2 rounded "
              >
                <span className="px-2 font-bold text-xl">
                  <IoCart />
                </span>
                | {languageHelper("add to cart") || "Add To Cart"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {alert && (
        <AlertModal
          alert={alert}
          handleCloseAlert={() => setAlert(false)}
        />
      )}
    </>
  );
}

function FeaturedCard({ menu, settings, subData, currency }) {
  const [showProduct, setShowProduct] = useState(false);
  const toggleProduct = () => {
    setShowProduct(!showProduct);
  };
  return (
    <>
      <div className="relative overflow-clip border transition-all hover:shadow-lg">
        <div className="relative w-full p-4">
          <img
            src={menu.photo_url}
            alt=""
            className="mx-auto size-32 lg:size-48 rounded-full"
            loading="lazy"
          />
          {/* <GoHeart className="text-2xl text-[#7B20C7] absolute top-2 right-2" /> */}
        </div>
        <div className="absolute top-2 left-2 space-y-2">
          {menu.discount?.length > 0 && (
            <div className="text-w-btn-text font-medium px-2 py-1 text-xs rounded-md w-fit bg-w-bg">
              {menu.discount[0]?.discount_amount}{" "}
              {menu.discount[0]?.dis_type === "percentage" ? "%" : currency || "S.R"}{" "}
              {languageHelper("off") || "Off"}
            </div>
          )}
          {menu?.is_new === "yes" && (
            <div className="text-w-btn-text font-medium px-2 py-1 text-xs rounded-md w-fit bg-w-bg">
              {languageHelper("new") || "New"}
            </div>
          )}
          {menu.out_of_stock && (
            <div className="text-w-btn-text font-medium px-2 py-1 text-xs rounded-md w-fit bg-w-bg">
              {languageHelper("out of stock") || "Out of Stock"}
            </div>
          )}
        </div>

        <div className="p-2">
          <div className="flex items-center justify-between gap-x-2">
            <h3 className="font-semibold text-w-heading">
              {defaultLang === "text_en" ? menu.name : menu.name_arabic}
            </h3>
          </div>
          <div className="md:flex justify-between my-4">
            <div>
              <div className="text-w-bg font-semibold lg:flex gap-2">
                <div
                  className={`${menu.discount?.length > 0 && "line-through"}`}
                >
                  {menu.sale_price} {currency || "S.R"}
                </div>
                {menu.discount?.length > 0 && (
                  <div>
                    {menu.sale_price -
                      (menu.discount[0]?.dis_type === "amount"
                        ? menu.discount[0]?.discount_amount
                        : menu.sale_price *
                        (menu.discount[0]?.discount_amount / 100))}{" "}
                    {currency || "S.R"}
                  </div>
                )}{" "}
              </div>
            </div>
            {settings?.add_to_cart === "active" && (
              <button
                className={`rounded-full bg-w-btn text-w-btn-text shadow-md size-5 ${menu.out_of_stock && "opacity-50"
                  }`}
                onClick={toggleProduct}
                disabled={menu.out_of_stock}
              >
                <FaPlus className="text-w-btn-text text-xs mx-auto" />
              </button>
            )}
          </div>
        </div>
      </div>

      {showProduct && (
        <ProductModal
          toggle={toggleProduct}
          menu={menu}
          settings={settings}
          subData={subData}
          currency={currency}
        />
      )}
    </>
  );
}

export default FeaturedCard;
